var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar ${_vm.state.question}`
                                  : "Nova FAQ"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text: "Lista de Perguntas e Respostas",
                              href: "#/faqs"
                            },
                            {
                              text: "Cadastro de Perguntas e Respostas",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Pergunta" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o pergunta",
                                      state: _vm.isOk("question")
                                    },
                                    model: {
                                      value: _vm.state.question,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "question", $$v)
                                      },
                                      expression: "state.question"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("question")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Resposta",
                                    "label-for": "input-2"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      placeholder: "Informe a resposta",
                                      rows: "3",
                                      "max-rows": "6",
                                      state: _vm.isOk("answer")
                                    },
                                    model: {
                                      value: _vm.state.answer,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "answer", $$v)
                                      },
                                      expression: "state.answer"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("answer")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Perfil",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.state.profile,
                                          expression: "state.profile"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.state,
                                            "profile",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione o perfil")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "consumer" } },
                                        [_vm._v("Consumidor")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "trader" } },
                                        [_vm._v("Comercializador")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "investor" } },
                                        [_vm._v("Investidor")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    class: {
                                      "is-invalid": !_vm.isOk("profile")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isOk("profile") === false
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(_vm._s(_vm.getError("profile")))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Categoria",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.state.category,
                                          expression: "state.category"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.state,
                                            "category",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione o perfil")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "ECONOMIZE" } },
                                        [_vm._v("Economize")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "COMERCIALIZE" } },
                                        [_vm._v("Comercialize")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "INVISTA" } },
                                        [_vm._v("Invista")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "ENERGIA" } },
                                        [_vm._v("Energia")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "OUTRAS" } },
                                        [_vm._v("Outras")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "VEINS" } },
                                        [_vm._v("Veins")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "LEGISLACAO" } },
                                        [_vm._v("Legislação")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    class: {
                                      "is-invalid": !_vm.isOk("category")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isOk("category") === false
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(_vm._s(_vm.getError("category")))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("image-upload", {
                                attrs: {
                                  currentUrl: this.state.url,
                                  updateUrl: _vm.updateUrl,
                                  setLoading: _vm.setLoadingPhoto
                                }
                              }),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.save(),
                                  label: "Salvar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }